import {Component, Input, OnInit, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { HttpErrorResponse } from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityModel } from '../../../../DataModels/entity-model';
import { EntityAddressModel } from '../../../../DataModels/entity-address-model';
import {EntityTypeModel} from '../../../../DataModels/entity-type-model';
import {LocationModel} from '../../../../DataModels/location-model';
import {AccountModel} from '../../../../DataModels/account-model';
import {BankModel} from '../../../../DataModels/bank-model';
import {CurrencyModel} from '../../../../DataModels/currency-model';
import {CompanyModel} from '../../../../DataModels/company-model';
import {TermModel} from '../../../../DataModels/term-model';
import {PaymentTypeModel} from '../../../../DataModels/payment-type-model';
import {TaxModel} from '../../../../DataModels/tax-model';
import { StorageService } from '../../../../Services/storage.service';
import {Observable, forkJoin, of} from 'rxjs';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { ResponseModel } from '../../../../DataModels/response-model';
import {BsToastService} from '../../../../Services/bs-toast-service';

@Component({
  selector: 'app-entity-detail',
  templateUrl: './entity-detail.component.html',
  styleUrls: ['./entity-detail.component.css'],
  standalone: false
})
export class EntityDetailComponent implements OnInit {
  isSaveNew = false;
  @Input() entityID: string;
  entity: EntityModel;
  entityForm: UntypedFormGroup;

  EntityTypeList: EntityTypeModel[];
  LocationList: LocationModel[];
  AccountList: AccountModel[];
  BankList: BankModel[];
  CurrencyList: CurrencyModel[];
  CompanyList: CompanyModel[];
  TermList: TermModel[];
  SalespersonList: any[] = [];
  ItemList: any[] = [];
  PaymentTypeList: PaymentTypeModel[];
  entityContactList: Array<object>;
  entities$: Observable<EntityModel[]>;
  entitiesList: EntityModel[];
  entityAddressList: Array<EntityAddressModel>;
  TaxList: TaxModel[];

  TaxLength = 0;
  contactLength = 1;
  addressLength = 0;
  itemdescriptionlength = 0;
  permissions: any;

  EntityValid = false;
  showMergeEntity = false;
  errorMessage: string;
  submitted = false;
  apArChecked = false;

  paid = false;

  reportDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
  loaded = false;

  constructor(
    private table: DataService,
    private notification: BsToastService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private localStorage: StorageService,
    private datePipe: DatePipe,
    private destroyRef: DestroyRef,
  ) {
    this.createForm();
  }

  get f() {
    return this.entityForm.controls;
  }

  ArOrApNotChecked(event: any) {
    // console.log('cb: ' + event.target.checked);
    this.apArChecked = event.target.checked;
    // console.log('checked var: ' + this.apArChecked);
  }

  createForm() {
    this.entityForm = this.formBuilder.group({
      id: new UntypedFormControl(null),
      name: new UntypedFormControl(null),
      type_id: new UntypedFormControl(null),
      // receivable: [false, Validators.requiredTrue],
      // payable: [false, Validators.requiredTrue],
      receivable: new UntypedFormControl(false),
      payable: new UntypedFormControl(false),
      tax_number: new UntypedFormControl(null),
      description: new UntypedFormControl(null),
      phone: new UntypedFormControl(null),
      fax: new UntypedFormControl(null),
      website: new UntypedFormControl(null),
      account_id: new UntypedFormControl(null),
      bank_id: new UntypedFormControl(null),
      company_id: new UntypedFormControl(null),
      salesperson_id: new UntypedFormControl(null),
      currency_id: new UntypedFormControl(null),
      location_id: new UntypedFormControl(null),
      payable_tax_1_id: new UntypedFormControl(null),
      payable_tax_1_rate: new UntypedFormControl(null),
      payable_tax_2_id: new UntypedFormControl(null),
      payable_tax_2_rate: new UntypedFormControl(null),
      payment_type_id: new UntypedFormControl(null),
      receivable_tax_1_id: new UntypedFormControl(null),
      receivable_tax_1_rate: new UntypedFormControl(null),
      receivable_tax_2_id: new UntypedFormControl(null),
      receivable_tax_2_rate: new UntypedFormControl(null),
      term_id: new UntypedFormControl(null),
      project_revenue_account_id: new UntypedFormControl(null),
      workorder_revenue_account_id: new UntypedFormControl(null),
      project_hours_item_id: new UntypedFormControl(null),
      workorder_hours_item_id: new UntypedFormControl(null),
      project_travel_item_id: new UntypedFormControl(null),
      workorder_travel_item_id: new UntypedFormControl(null),
      email: new UntypedFormControl(null),
      email_name: new UntypedFormControl(null),
      statement_last_sent_date: new UntypedFormControl(null),
      credit_limit: new UntypedFormControl('', {validators: Validators.pattern(/^\d+(\.\d+)?$/), updateOn: 'blur'}),
      active: new UntypedFormControl(true),
      account: new UntypedFormControl(null),
      banks: new UntypedFormControl(null),
      currency: new UntypedFormControl(null),
      entity_address: new UntypedFormControl([]),
      entity_contact: new UntypedFormControl([]),
      entity_type: new UntypedFormControl(null),
      location: new UntypedFormControl(null),
      payment_type: new UntypedFormControl(null),
      entity_salesperson: new UntypedFormControl([]),
      tax: new UntypedFormControl(null),
      tax1: new UntypedFormControl(null),
      tax2: new UntypedFormControl(null),
      tax3: new UntypedFormControl(null),
      term: new UntypedFormControl(null),
      locations: new UntypedFormControl(null),
      mergeEntityInput: new UntypedFormControl(null),
    });
  }

  ngOnInit() {
    this.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    // Bootstrap loads in parallel and flip loader once when all are done
    this.route.params.pipe(
      map(params => params.id as string | undefined),
      take(1),
      switchMap((id) => {
        if (id) {
          this.entityID = id;
        }

        const entity$ = this.entityID
          ? this.table.getData('entity', this.entityID).pipe(
            take(1),
            catchError(err => {
              console.error('Entity:', err);
              return of(null);
            })
          )
          : of(null);

        const entityTypes$ = this.table.getApiListData('Entity_type', '?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Entity Types:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const location$ = this.table.getData('location?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Locations:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const accounts$ = this.table.getData('account?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Accounts:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const tax$ = this.table.getData('tax?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Tax:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const paymentType$ = this.table.getData('payment_type?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Payment Type:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const entityContacts$ = this.table.getApiListData('entity_contact', '?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Entity Contacts:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const bank$ = this.table.getData('bank?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Bank:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const currency$ = this.table.getData('currency?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Currency:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const company$ = this.table.getData('company?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Company:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const term$ = this.table.getData('term?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Term:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        const salesperson$ = this.table.getApiListData('salesperson', '?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Salesperson:', err);
            return of({data: []} as any);
          })
        );

        const item$ = this.table.getData('item?pageNumber=0&pageSize=999999').pipe(
          take(1),
          catchError(err => {
            console.error('Items:', err);
            return of({Data: []} as ResponseModel);
          })
        );

        return forkJoin({
          entity: entity$,
          entityTypes: entityTypes$,
          location: location$,
          accounts: accounts$,
          tax: tax$,
          paymentType: paymentType$,
          entityContacts: entityContacts$,
          bank: bank$,
          currency: currency$,
          company: company$,
          term: term$,
          salesperson: salesperson$,
          item: item$,
        });
      })
    ).subscribe(({
                   entity,
                   entityTypes,
                   location,
                   accounts,
                   tax,
                   paymentType,
                   entityContacts,
                   bank,
                   currency,
                   company,
                   term,
                   salesperson,
                   item
                 }) => {
      // Apply results
      if (entity) {
        this.entity = entity as any;
        if ((this.entity as any).payable || (this.entity as any).receivable) {
          this.apArChecked = true;
        }
        this.entityForm.patchValue(this.entity);
      }
      this.EntityTypeList = (entityTypes as ResponseModel)?.Data || [];
      this.EntityValid = true;
      this.LocationList = (location as ResponseModel)?.Data || [];
      this.AccountList = (accounts as ResponseModel)?.Data || [];
      this.TaxList = (tax as ResponseModel)?.Data || [];
      this.TaxLength = this.TaxList.length || 0;
      this.PaymentTypeList = (paymentType as ResponseModel)?.Data || [];
      this.entityContactList = (entityContacts as ResponseModel)?.Data || [];
      this.contactLength = this.entityContactList?.length || 0;
      this.BankList = (bank as ResponseModel)?.Data || [];
      this.CurrencyList = (currency as ResponseModel)?.Data || [];
      this.CompanyList = (company as ResponseModel)?.Data || [];
      this.TermList = (term as ResponseModel)?.Data || [];
      this.SalespersonList = (salesperson as any)?.Data ?? (salesperson as any)?.data ?? [];
      this.ItemList = (item as ResponseModel)?.Data || [];

      // Flip loader once
      this.loaded = true;
    });
  }

  LoadEntity() {
    this.table.getData('entity', this.entityID).subscribe(
      (result: any) => {
        this.entity = result;
        // console.log(JSON.stringify(this.entityID));
        // console.log(JSON.stringify(result));
        if (result.payable || result.receivable) {
          this.apArChecked = true;
        }
      },
      (error: HttpErrorResponse) => {
        // this.notification.error(
        //   $localize`:Error loading Entity Access @@errorloadingEntityAccess:Error loading Entity Access`
        // );
        console.log(error);
      },
      () => {
        this.entityForm.patchValue(this.entity);
      }
    );
  }

  LoadEntity_Types() {
    this.table.getApiListData('Entity_type', '?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.EntityTypeList = result.Data;
        this.EntityValid = true;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  loadLocation() {
    this.table.getData('location?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.LocationList = result.Data;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  loadBank() {
    this.table.getData('bank?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.BankList = result.Data;
      },
      (error: HttpErrorResponse) => {
        //
        // this.notification.error($localize`:Load Bank error @@LoadBankerror:Load Bank error: ` + error);
      },
      () => {
        //
      }
    );
  }

  loadCurrency() {
    this.table.getData('currency?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.CurrencyList = result.Data;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  loadCompany() {
    this.table.getData('company?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.CompanyList = result.Data;
      },
      (error: HttpErrorResponse) => {
        //
       },
      () => {
        //
      }
    );
  }

  loadTerm() {
    this.table.getData('term?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.TermList = result.Data;
      },
      (error: HttpErrorResponse) => {
        //
        // this.notification.error('Load Term error: ' + error);
      },
      () => {
        //
      }
    );
  }

  loadEntityContacts() {
    this.table.getApiListData('entity_contact', '?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.entityContactList = result.Data;
        this.contactLength = this.entityContactList.length;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  private loadTax() {
    this.table.getData('tax?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.TaxList = result.Data;
        this.TaxLength = this.TaxList.length;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  private loadAccounts() {
    this.table.getData('account?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.AccountList = result.Data;
        // this.companyListLength = this.companyList.length;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  private loadPaymentType() {
    this.table.getData('payment_type?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        this.PaymentTypeList = result.Data;
        // this.companyListLength = this.companyList.length;
      },
      (error: HttpErrorResponse) => {
        //
      },
      () => {
        //
      }
    );
  }

  loadEntities() {
    this.table.getApiListData('entity', '?pageNumber=0&pageSize=999999').subscribe((res: ResponseModel) => {
      const data: any = res.Data;
      this.entities$ = data;
      this.entitiesList = [];
      data.forEach((x) => {
        if (x.id !== this.entityID) {
          this.entitiesList.push(x);
        }
      });
    });
  }

  private CheckForErrors(): boolean {
    this.submitted = true;
    this.errorMessage = '';
    if (
      !this.permissions.AllEntities &&
      !this.permissions.EditReceivableEntities &&
      !this.permissions.EditPayableEntities &&
      !this.permissions.Admin
    ) {
      this.errorMessage = $localize`:You do not have access to create or edit entities.  @@youdonothaveaccesstocreateoreditentities:You do not have access to create or edit entities. `;
      this.notification.showWarningToast(this.errorMessage);
      return false;
    } else if (this.entityForm.invalid || this.apArChecked === false) {
      this.errorMessage += $localize`:Form errors. @@formerrors:Form errors.`;
      this.notification.showWarningToast(this.errorMessage);
      return false;
    } else {
      return true;
    }
  }

  private resetToDefaults(): void {
    // Reset the form to known defaults for a fresh entry
    this.entityForm.reset({
      id: null,
      name: null,
      type_id: null,
      receivable: false,
      payable: false,
      tax_number: null,
      description: null,
      phone: null,
      fax: null,
      website: null,
      account_id: null,
      bank_id: null,
      company_id: null,
      salesperson_id: null,
      currency_id: null,
      location_id: null,
      payable_tax_1_id: null,
      payable_tax_1_rate: null,
      payable_tax_2_id: null,
      payable_tax_2_rate: null,
      payment_type_id: null,
      receivable_tax_1_id: null,
      receivable_tax_1_rate: null,
      receivable_tax_2_id: null,
      receivable_tax_2_rate: null,
      term_id: null,
      project_revenue_account_id: null,
      workorder_revenue_account_id: null,
      project_hours_item_id: null,
      workorder_hours_item_id: null,
      project_travel_item_id: null,
      workorder_travel_item_id: null,
      email: null,
      email_name: null,
      statement_last_sent_date: null,
      credit_limit: '',
      active: true,
      account: null,
      banks: null,
      currency: null,
      entity_address: [],
      entity_contact: [],
      entity_type: null,
      location: null,
      payment_type: null,
      entity_salesperson: [],
      tax: null,
      tax1: null,
      tax2: null,
      tax3: null,
      term: null,
      locations: null,
      mergeEntityInput: null,
    });
    this.entity = {} as EntityModel;
    this.entityID = null;
    this.submitted = false;
    this.errorMessage = '';
    this.apArChecked = false;
  }

  onSave(saveClose: boolean): boolean {
    // zap all the stuff on the form not a part of the model because object assign sucks and ignores model.
    this.submitted = true;
    delete this.entityForm.value.banks;
    delete this.entityForm.value.entity_address;
    delete this.entityForm.value.locations;
    delete this.entityForm.value.entity_salesperson;
    delete this.entityForm.value.entity_contact;
    // this.entity = Object.assign({}, this.entityForm.value);

    const result: EntityModel = Object.assign({}, this.entityForm.value);
    this.entity = result;

    if (this.CheckForErrors()) {
      if (this.entity.id != null) {
        this.table.patch('entity', this.entity.id, this.entity).then(
          () => {
            if (saveClose) {
              this.router.navigate(['entity-list']).then();
            } else if (this.isSaveNew) {
              this.isSaveNew = false;
              this.resetToDefaults();
            }
          },
          (error: HttpErrorResponse) => {
            console.log(error);
          }
        ).finally(() => {
          this.submitted = false;
        });
      } else {
        this.table.postWithPromise('entity', this.entity).then((res) => {
          let apiReturn: any = null;
          if (typeof res === 'object') {
            apiReturn = JSON.parse(JSON.stringify(res));
          }
          this.entity.id = apiReturn?.id;
          if (saveClose) {
            this.router.navigate(['entity-list']).then();
          } else if (this.isSaveNew) {
            this.isSaveNew = false;
            this.resetToDefaults();
          }
        }).catch((error: HttpErrorResponse) => {
          console.log(error);
        }).finally(() => {
          this.submitted = false;
        });
      }
      return true;
    }
    this.submitted = false;
    return false;
  }

  merge() {
    const ParamsJson = {
      merge_to_entity_id: this.entity.id,
      delete_entity_id: this.entityForm.get('mergeEntityInput').value,
    };

    if (this.entity.id === this.entityForm.get('mergeEntityInput').value) {
      this.notification.showWarningToast(
        $localize`:Cannot merge to the same address @@cannotmergetothesameaddress:Cannot merge to the same address`
      );
    } else {
      const Param: string = this.encodeQueryData(ParamsJson);
      this.table.getData('MergeEntity', '?' + Param).subscribe(
        (result) => {},
        (error: HttpErrorResponse) => {
          console.log(error);
        },
        () => {}
      );
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  changeToDecimal(fieldName: string) {
    let value = this.entityForm.get(fieldName)?.value;
    if (value) {
      value = parseFloat(value).toFixed(2);
      this.entityForm.get(fieldName)?.setValue(value, {emitEvent: false});
    }
  }
}
